import React, { useState } from 'react';
import { Box, Button, Typography, TextField, Modal } from '@mui/material';
import { useDispatch } from 'react-redux';
import {
  generateQuestion,
  getGptQuestionGenerateState,
} from '../../../../store/GptQuestionGenerateSlice';
import { useAppSelector } from '../../../../hooks';

export interface IGenerateQuizChangeCriteriaModal {
  open: boolean;
  onClose: () => void;
}

const GenerateQuizChangeCriteriaModal: React.FC<IGenerateQuizChangeCriteriaModal> = ({
  open,
  onClose,
}) => {
  const [criteria, setCriteria] = useState('');

  const gptSate = useAppSelector(getGptQuestionGenerateState);
  const dispatch = useDispatch();

  const handleGenerate = () => {
    dispatch(
      generateQuestion({ message: criteria, threadId: gptSate.threadId })
    );
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          maxWidth: 500,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: '20px',
        }}
      >
        <Typography
          id="modal-title"
          component="h2"
          sx={{
            fontWeight: 'bold',
            fontSize: '1.05rem',
            mb: '20px',
            textAlign: 'center',
          }}
        >
          Change criteria
        </Typography>
        <TextField
          fullWidth
          label="Criteria"
          multiline
          rows={5}
          placeholder="Type here..."
          value={criteria}
          onChange={(e) => setCriteria(e.target.value)}
          sx={{ mb: '15px' }}
        />

        <Button
          variant="contained"
          color="inherit"
          onClick={onClose}
          sx={{ mt: 2 }}
        >
          Dismiss
        </Button>
        <Button
          variant="contained"
          disabled={criteria.length < 4}
          onClick={handleGenerate}
          sx={{ mt: 2, ml: 2, float: 'inline-end' }}
        >
          Submit
        </Button>
      </Box>
    </Modal>
  );
};

export default GenerateQuizChangeCriteriaModal;
